module.exports = __webpack_public_path__ + "img/wang.4c468971.png";